import { createFileRoute } from '@tanstack/react-router';
import { RoleCreateForm } from '../../modules/roles/role-create-form.js';

export const Route = createFileRoute('/roles/new')({
  component: NewRolePage,
});

// eslint-disable-next-line react-refresh/only-export-components
function NewRolePage() {
  return <RoleCreateForm />;
}
